export default {
  ALL: state => state.assignments,
  ASSIGNMENT: state => assignmentId => state.assignments[assignmentId],
  FOR_SECTION: state => sectionId => {
    if (state.assignmentsForSectionMap[sectionId]) {
      return state.assignmentsForSectionMap[sectionId].map(a => state.assignments[a]);
    }
    return [];
  },

  SUBMISSIONS: state => assignmentId => state.submissionsForAssignmentMap[assignmentId] || [],
  SUBMISSION: state => (assignmentId, submissionId) => {
    const submissions = state.submissionsForAssignmentMap[assignmentId];
    if (submissions) {
      return submissions.find(s => s.id === submissionId);
    }
    return null;
  },

  CATEGORIES: state => assignmentId => state.categoriesForAssignments[assignmentId] || [],

  GRADE_TYPES: state => state.gradeTypes || [],
  GRADE_TYPE_FOR_ASSIGNMENT: state => assignmentId => state.assignmentGradeTypeMap[assignmentId] || []
};
